export const mockedNews = [
  {
    id: 1, addTime: 1500000000000, time: 1500000000000,
    shortText: `Vážení přátelé,
    podpořte svého oblíbeného umělce (tedy kapelu DOKTOR TRICERATOPS) tím, že mu dáte "lajk" v této soutěži:
    http://sance.muzikus.cz/
    Předem děkujeme. `,
    fullText: 'Tohle je testnovinka, tak se k ní tak chovejte.'
  }, {
    id: 2, addTime: 1510000000000, time: 1510000000000,
    shortText: 'Tohle je test novinka číslo dva.',
    fullText: 'Tohle je testnovinka2, tak se k ní tak chovejte.'
  }, {
    id: 3, addTime: 1600000000000, time: 1600000000000,
    shortText: 'Tohle je test novinka číslo tři.',
    fullText: 'Tohle je testnovinka3, tak se k ní tak chovejte.'
  }
];